import React from 'react';
import { CloudUploadOutlined } from '@ant-design/icons';

const UploadPreview = () => {
  return (
    <div
      style={{
        height: 120,
        aspectRatio: 1,
        background: 'white',
        borderRadius: 12,
        border: '1px dashed #D2DDEC',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        textAlign: 'center',
      }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 16,
          padding: 16,
        }}>
        <CloudUploadOutlined />
        <div
          style={{
            color: '#6C6C6C',
          }}>
          Drop files here to upload
        </div>
      </div>
    </div>
  );
};

export default UploadPreview;
